import { render, staticRenderFns } from "./rankings.vue?vue&type=template&id=327045cc&scoped=true"
import script from "./rankings.vue?vue&type=script&lang=js"
export * from "./rankings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327045cc",
  null
  
)

export default component.exports